import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { timezoneOptions } from './timezoneMappings';

const TimezoneSelector = ({onChange, error = false, className = null, disabled = false, currentTimezone}) => {
  const [selectedTimezone, setSelectedTimezone] = useState();

  // Handle selection changes.
  const handleChange = (selectedOption) => {
    setSelectedTimezone(selectedOption);

    if(onChange) {
        onChange(selectedOption)
    }
  };

  const getClasses = () => {
    let classes = `rounded mb-1 min-w-72 max-w-md h-9 mr-4 ${className}`

    if(error){
        classes += " border-red-500"
    }
    if(disabled){
        classes += " cursor-not-allowed bg-gray-200"
    }
    return classes
}

  useEffect(() => {

    if(!currentTimezone) return

    const currentOption = timezoneOptions.find(tz => tz.value === currentTimezone)

    // a stored code with no option must not reach the parent as undefined
    if(!currentOption) return

    handleChange(currentOption)

  }, [currentTimezone]) //eslint-disable-line

  return (
    <Select
      id="timezone-select"
      value={selectedTimezone}
      onChange={handleChange}
      options={timezoneOptions}
      isDisabled={disabled}
      className={getClasses()}
    />
  );
};

export default TimezoneSelector;
